import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { StaticMessage } from "./index";
import { toaster } from "rsuite";
var Duration;
(function (Duration) {
    Duration[Duration["success"] = 4000] = "success";
    Duration[Duration["info"] = 6000] = "info";
    Duration[Duration["warning"] = 8000] = "warning";
    Duration[Duration["error"] = 30000] = "error";
    Duration[Duration["default"] = 6000] = "default";
})(Duration || (Duration = {}));
const getDuration = (type) => {
    switch (type) {
        case "success":
            return Duration.success;
        case "info":
            return Duration.info;
        case "warning":
            return Duration.warning;
        case "error":
            return Duration.error;
        default:
            return Duration.default;
    }
};
const PopUpMessage = (props) => {
    const { type, message, header, onClose } = props;
    toaster.push(_jsx(StaticMessage, { message: message, type: type, header: header, bordered: true, onClose: onClose }), {
        duration: getDuration(type)
    });
};
export default PopUpMessage;
